import {createAction, handleActions} from 'redux-actions';
import {generateUUID, getDate, getTime, getTotalProductPrice, priceToFix, roundSum} from '../helpers/productHelper';
import {TICKET_CALC_DATA_RECEIVED} from '../config/const';
import {getCurrentCustomerType} from '../selectors/customer_type_selector';
import { getSalesChannelName } from '../selectors/sales_channel_selectors';

export const addProductAction = createAction('PRODUCT_ADD', product => product);
export const addProductsAction = createAction('PRODUCTS_ADD', products => products);
export const increaseProductQnt = createAction('PRODUCT_ADD_UNIT', productId => productId);
export const cartUpdated = createAction('CART_UPDATED');
export const substructProductQnt = createAction('PRODUCT_SUBTRACT_UNIT', productId => productId);
export const removeProduct = createAction('PRODUCT_REMOVE', productId => productId);
export const resetCart = createAction('CART_RESET');
export const ticketCalcDataReceieved = createAction(TICKET_CALC_DATA_RECEIVED);

const initialState = {};

export default handleActions({
  PRODUCT_ADD: (state, action) => {
    const item = action.payload;
    const cart = {...state};

    if (!cart[item.productId]) {
      const itemWithRoundPrice = {
        ...item,
        priceSell: item.priceSell,
        createdAt: new Date(),
        unitOfMeasurement: item.unitOfMeasurement,
        size: item.size,
      };
      cart[item.productId] = itemWithRoundPrice;
    } else {
      cart[item.productId].quantity += item.quantity;
    }
    return cart;
  },
  PRODUCTS_ADD: (state, action) => {
    const items = action.payload;
    const cart = {...state};
    for (const item of items) {
      if (!cart[item.productId]) {
        const itemWithRoundPrice = {
          ...item,
          priceSell: item.priceSell,
          unitOfMeasurement: item.unitOfMeasurement,
          size: item.size,
        };
        cart[item.productId] = itemWithRoundPrice;
      } else {
        cart[item.productId].quantity += item.quantity;
      }
    }
    return cart;
  },
  PRODUCT_SUBTRACT_UNIT: (state, action) => {
    const itemId = action.payload;
    const cart = {...state};
    if (cart[itemId] && cart[itemId].quantity > 1) {
      cart[itemId].quantity -= 1;
    }
    return cart;
  },
  PRODUCT_ADD_UNIT: (state, action) => {
    const itemId = action.payload;
    const cart = {...state};
    if (cart[itemId]) {
      cart[itemId].quantity += 1;
    }
    return cart;
  },
  PRODUCT_REMOVE: (state, action) => {
    const itemId = action.payload;
    const cart = {...state};
    if (cart[itemId]) {
      delete cart[itemId];
    }
    return cart;
  },
  LOGOFF: (state, action) => initialState,
  CART_RESET: (state, action) => initialState
}, initialState);

export const addProduct = (product) => (dispatch, getState) => {
  dispatch(addProductAction({ 
    ...product, 
    customerType: getCurrentCustomerType(getState()),
    salesChannelName: getSalesChannelName(getState()) 
  }))
};

export const addProducts = (products) => (dispatch, getState) => {
  const currentCustomerType = getCurrentCustomerType(getState());
  const productsWithCustomerType = products.map(product => {
    product.customerType = currentCustomerType;
    return product;
  })

  dispatch(addProductsAction(productsWithCustomerType))
};

// - Selectors
/* Return total number of items in cart */
export const getCartQuantity = (state) => {
  const cart = state.cart;
  const keys = Object.keys(cart);
  let totalQty = 0;
  for (const key of keys) {
    totalQty += cart[key].quantity;
  }
  return totalQty;
};
export const getSubTotal = (state) => {
  const cart = state.cart;
  const keys = Object.keys(cart);
  let total = 0.0;
  for (const key of keys) {
    total += cart[key].priceSell * cart[key].quantity;
  }
  return roundSum(total);
};
export const getTotal = (state) => {
  const cart = state.cart;
  const deliveryFee = state.config.DELIVERY_COST;
  const tax = Number(getTax(state));
  const isDelivery = state.address.isDelivery;
  const delivery = isDelivery && deliveryFee && Object.keys(cart).length > 0 ? Number(priceToFix(deliveryFee)) : 0.0;
  const subTotal = Number(getSubTotal(state));
  // return roundSum(Number(getSubTotal(state)) + Number(getTax(state)));
  return roundSum(subTotal + tax + delivery);
};
export const getItems = (state) => {
  const cart = state.cart;
  const keys = Object.keys(cart);
  const items = [];
  for (const itemId of keys) {
    items.push(cart[itemId]);
  }
  return items;
};

/**
 * Returns units amount of a product in cart
 * @param {*} state
 * @param {*} productId
 */
export const getItemQnt = (state, productId) => {
  const cart = state.cart;
  if (!cart[productId]) return 0;
  return cart[productId].quantity;
};

export const getTax = (state) => {
  const cart = state.cart;
  const keys = Object.keys(cart);
  // let items = [];
  let tax = 0;
  for (const itemId of keys) {
    const item = cart[itemId];
    tax += (getTotalProductPrice(item, '1') - item.priceSell) * item.quantity;
  }
  return roundSum(tax);
};

export const getTicketlines = (state) => {
  const cart = state.cart;
  const ticketItems = [];
  Object.values(cart).forEach((item, index) => {
    ticketItems.push({
      createdAt: item.createdAt,
      runningPrice: item.priceSell,
      price: item.priceSell,
      originalPrice: item.priceSell,
      discountPrice: item.priceSell,
      productId: item.productId,
      unit: item.quantity,
      tax: 0.095,
      weight: 0.5,
      discount: 0.0,
      taxOther: 0.0,
      discountDescription: '',
      customerType: item.customerTypes,
    });
  });
  return {ticketItems};
};

export const getOrder = (state) => {
  const uuid = generateUUID().substr(0, 4);
  const customer = `${state.customer.firstName} ${state.customer.lastName}`;
  const customerId = state.customer.driverLicenseId;
  const order = {
    orderDate: getDate(),
    orderAddress: 'Address not available',
    orderTime: getTime(),
    merchantId: '00001111',
    term: '00000000',
    orderId: uuid,
    customerName: customer,
    patientId: customerId,
    storeId: '000001',
    items: getItems(state),
    subTotal: getSubTotal(state),
    tax: getTax(state),
    total: getTotal(state),
    cash: getTotal(state),
    change: 0
  };
  return order;
};



// WEBPACK FOOTER //
// ./src/reducers/cartReducer.js